import { defineMessages } from 'react-intl';

export default defineMessages({
  title: { defaultMessage: 'Select preferred network' },

  mainnet: { defaultMessage: '{network}' },
  testNetwork: { defaultMessage: '{network} Test Network' },
  forkNetwork: { defaultMessage: '{network} Fork Network' },
});
